import KeyCollectionItem from './key_collection_item';

export default KeyCollectionItem;
